import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import DividerComponent from 'components/Divider/Divider';
import InfoBox from 'components/InfoBox/InfoBox';
import RouterStepper from 'components/Stepper/RouterStepper';
import { LargeHeader } from 'components/Text';
import useTerminateInactiveTag from 'hooks/tags/useTerminateInactiveTag';
import { HOME } from 'routes/home/paths';
import { TAG_DETAILS } from 'routes/overview/paths';
import ChooseTag from './ChooseTag';
export default function TerminateInactiveTag() {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    tagNumber
  } = useParams();
  const {
    isLoading,
    isValid,
    terminateInactiveTag
  } = useTerminateInactiveTag();
  const backClick = () => {
    return tagNumber ? push(TAG_DETAILS(tagNumber)) : push(HOME);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LargeHeader, null, t('terminate_inactive_tag.title')), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ChooseTag, null), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(InfoBox, {
    warning: true,
    mb: 3
  }, t('terminate_inactive_tag.warning')), /*#__PURE__*/React.createElement(RouterStepper, {
    onBackButtonClick: backClick,
    onForwardButtonClick: terminateInactiveTag,
    hasForwardButtonDisabled: !isValid,
    altForwardButtonText: t('terminate_inactive_tag.submit'),
    isForwardButtonLoading: isLoading,
    isFinalStep: true
  }));
}